import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@material-ui/core';

const VideoUploader = props => {
  const { t } = useTranslation();
  const { errors, onClose, width } = props;

  return (
    <Box width={width}>
      {errors.map(error => {
        return (
          <Typography key={error} variant="body1" color="secondary">
            {error}
          </Typography>
        );
      })}
      <Box mt={3}>
        <Button variant="contained" color="primary" disabled={false} onClick={onClose}>
          {t('components.VideoUpload.closeButtonText')}
        </Button>
      </Box>
    </Box>
  );
};

VideoUploader.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClose: PropTypes.func.isRequired,
  width: PropTypes.string.isRequired,
};

export default VideoUploader;



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoUploader/components/Error/Error.js